module.exports = __webpack_public_path__ + "31804be3b9500ad16ce70d83d4bcaeb7.jpg";